
export default function SliderCardUi() {
    return (
        <div className="flex_col gap-4 my-3 py-3">
            <p className="text-start text-xl font-bold">
                پزشکان دیگر با همین تخصص:
            </p>
            <div className="grid-cols-2 gap-3 w-auto">
                {/* <CardSlider />
        <CardSlider /> */}
            </div>
        </div>
    );
}
